<template>
  <v-container
    class="fill-height bg-login pt-0"
    fluid
    style="align-items: start"
  >
    <v-row justify="center">
      <v-col cols="auto white elevation-4 rounded-bl-xl rounded-br-xl">
        <v-img
          :src="'../images/company-logo.png'"
          max-width="200"
          class="mx-auto"
        />
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" md="8" lg="6">
        <p
          class="white--text font-weight-bold text-elevation-4 text-center text-xl-h2 text-lg-h3 text-h4"
        >
          Welcome to <br />XuYuan Class
        </p>
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="form.post('/login')">
              <div class="label mb-2">Email</div>
              <v-text-field
                v-model="form.username"
                :rules="[validationRules.required, validationRules.email]"
                solo
                flat
                outlined
                dense
              />
              <div class="label mb-2">Password</div>
              <v-text-field
                v-model="form.password"
                solo
                flat
                outlined
                dense
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                :rules="[validationRules.required]"
                @click:append="showPassword = !showPassword"
              />
              <v-checkbox
                v-model="form.remember"
                label="Remember Me?"
              ></v-checkbox>
              <v-btn
                block
                large
                color="primary"
                type="submit"
                :disabled="form.processing"
                :loading="form.processing"
                >Login</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LayoutBlank from '@layouts/Blank'

export default {
  name: 'Login',
  layout: LayoutBlank,
  data() {
    return {
      showPassword: false,
      form: this.$inertia.form({
        username: null,
        password: null,
        remember: false,
      }),
    }
  },
}
</script>
<style lang="scss" scoped>
.top-center {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  width: 200px;
  height: 300px;
}
</style>
